import { Suspense } from "react";
import { Activity } from "react";
import styles from "./AppLayout.module.css";
import { Header } from "../header/header";
import { NavigationPanel } from "../navigationPanel/navigationPanel";
import { RouteLoadingBar } from "../ui/routeLoadingBar";
import { useNavigationPanel } from "../../hooks/context/useNavigationPanel";
import { useMediaQuery } from "../../hooks/useMediaQuery";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { isOpen } = useNavigationPanel();
  const isDesktop = useMediaQuery("(min-width: 600px)");

  return (
    <div className={styles.app}>
      <Header />
      <div className={styles.layout}>
        <Activity mode={isOpen ? "visible" : "hidden"}>
          <aside className={styles.sidebar} aria-hidden={!isDesktop && !isOpen}>
            <NavigationPanel />
          </aside>
        </Activity>
        <main className={styles.main}>
          <RouteLoadingBar />
          <Suspense fallback={<div className={styles.loader}>Loading...</div>}>
            {children}
          </Suspense>
        </main>
      </div>
    </div>
  );
}
